export const uk = {
    'accept-button': 'Применить',
    'no-rights': 'Недостаточно прав для применения рекомендации',
    'progress-accept-button': 'Применяем'
};
